import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { DataCacheService } from './data-cache.service';
import { ROLES } from './auth.service';
import { ApiStaffService } from './api-call-providers/api-staff.service';
import { COOKIES_CONFIG } from './../configs/cookies.config';

export class Staff {

  staffName: string = '';

  staffId: string = '';
  name: string = '';
  nameKana: string = '';
  staffLoginId: string = '';
  gender: string = '';
  role: string = '';
  roleName: string = '';

  wardName:string = '';
  unitName:string = '';
  memo:string = '';

  isSoftDeleted: boolean = false;

  constructor(data) {
    this.staffId = data.patientId;
    this.staffName = data.staffName;
    this.staffLoginId = data.staffLoginId;

    this.name = data.name;
    this.nameKana = data.nameKana;
    this.gender = data.gender;
    this.role = data.role;
    this.roleName = data.roleName;

    this.wardName = data.wardName;
    this.unitName = data.unitName;
    this.memo = data.memo;
    this.isSoftDeleted = data.isSoftDeleted || false;
  }
}

@Injectable()
export class StaffService {

  // スタッフ一覧
  private staffsSource = new Subject<any>();
  staffs = this.staffsSource.asObservable();

  // スタッフ登録
  private registStaffSource = new Subject<any>();
  registStaff = this.registStaffSource.asObservable();

  // スタッフ一括登録
  private bulkRegistStaffSource = new Subject<any>();
  bulkRegistStaff = this.bulkRegistStaffSource.asObservable();

  // スタッフ更新
  private updateStaffSource = new Subject<any>();
  updateStaff = this.updateStaffSource.asObservable();

  constructor(
    private _dataCacheService: DataCacheService,
    private apiStaffService: ApiStaffService,
  ) {
  }

  get loading() {
    return this.apiStaffService.isLoading
  }

  /**
   * データの初期化
   */
  async load() {
    this.apiStaffService.isLoading = true
    let data = await this._dataCacheService.get(COOKIES_CONFIG.STAFFS_DATA)
    if (!data.isExist()) {
      // キャッシュデータが古い or ない場合、データロード
      await this.fetch();
      return
    }
    this.apiStaffService.isLoading = false;
    return this.staffsSource.next(data);
  }

  /**
   * APIからリスト取得する
   * @param params
   */
  async fetch() {
    let res: any = await this.apiStaffService.list()
    let data = { data: res.staffList }
    if (res.expired) {
      data = await this._dataCacheService.set(COOKIES_CONFIG.STAFFS_DATA, res.staffList, res.expired)
    }
    this.staffsSource.next(data)
  }

  /**
   * スタッフリスト取得
   * @param params
   */
  // list(isCache:boolean = false): Promise<any> {

  //   return this.apiStaffService.list().then((res) => {
  //     if (res) {
  //       this.staffs = res.staffList;
  //       return;
  //     }
  //   }).catch(() => {
  //     return this.staffs;
  //   })
  // }

  /**
   * スタッフ情報登録
   * @param params
   */
  async regist(params) {
    await this.apiStaffService.post(params)
    await this.fetch()
    this.registStaffSource.next()
  }

  /**
   * スタッフ情報一括登録
   * @param params
   */
  async bulkRegist(params) {
    await this.apiStaffService.bulkPost(params);
    await this.fetch();
    this.bulkRegistStaffSource.next();
  }

  /**
   * スタッフ情報更新
   * @param params
   */
  async update(params) {
    await this.apiStaffService.update(params)
    await this.fetch()
    this.updateStaffSource.next()
  }

  /**
   * スタッフ情報物理削除
   * @param params
   */
  async delete(params) {
    await this.apiStaffService.delete(params)
    await this.fetch()
  }

  /**
   * スタッフ情報論理削除
   * @param params
   */
  async softDelete(params) {
    await this.apiStaffService.softDelete(params)
    await this.fetch()
  }

  /**
   * ロール情報を付与して返す
   * @param staffs []
   */
  async setRole(staffs) {
    return staffs.map((staff: Staff) => {
      let roleData = ROLES.find(_role => {
        return _role.value === staff.role;
      });
      staff.roleName = (roleData)?`[${roleData.name}権限]`:'[一般権限]';
      return staff
    })
  }

}



// WEBPACK FOOTER //
// ./src/providers/staff.service.ts